// lazyload
jQuery(function($) {
  $('body').imagesLoaded(function(){
    var _mql = window.matchMedia('screen and (max-width: 767px)');
    var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
    var $video = document.getElementById('js-home-kv');
    var _videoSrc;
    var _videoPcSrc;
    if ($video != null) {
      // ▼本番用
      //https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/
      // _videoSrc = 'https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/kv/video.mp4';
      // _videoPcSrc = 'https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/kv/video-pc.mp4';
      // ▼ローカル開発用
      _videoSrc = './assets/image/kv/video.mp4';
      _videoPcSrc = './assets/image/kv/video-pc.mp4';
      _mql.addListener(routingByBreakpoint);
      // ▼初回ロード時
      routingByBreakpoint(_mql);
      // console.log('あるしんど');
      $($video).imagesLoaded(function(){
        $('#js-loading').addClass('is-hidden');
        $('#js-body').addClass('is-show');
      });
    } else {
      // console.log('あれ');
      $('#js-loading').addClass('is-hidden');
      $('#js-body').addClass('is-show');
    }
    // ▼関数
    function routingByBreakpoint(_mql) {
      if (_mql.matches) {
        $video.src = _videoSrc;
        $video.load();
        $video.play();
        // console.log('spサイズだお');
      } else {
        $video.src = _videoPcSrc;
        $video.load();
        $video.play();
        // console.log('pcサイズだお');
      }
    }
  });
  // $('#js-loading').imagesLoaded(function(){
    // // bodyの画像数を取得
    // var imgNum = imagesLoaded('body').images.length;
    // // 読み込んだ画像の数を格納
    // var loadedImg = 0;
    // // 現在のプログレス値を格納
    // var progressNowPosition = 0;
    // // 1秒間に50回、progressMonitor()を実行する
    // Timer = setInterval(progressMonitor, 1000 / 50);
    // // ローディング解除関数
    // function clearLoadWindow() {
    //   clearInterval(Timer);
    //   $('#js-loading').addClass('is-hidden');
    //   $('#js-body').addClass('is-show');
    // }
    // // 画像を読み込んだらloadedImgを加算する
    // imagesLoaded('body').on('progress', function() {
    //   loadedImg++;
    // });
    //
    // // 画像の読み込み状況をチェックし、更新する関数
    // function progressMonitor() {
    //   // 読み込んだ画像のパーセンテージ
    //   var progressPosition = (loadedImg / imgNum) * 100;
    //   // プログレス値を現在値と目標値からイージングする
    //   progressNowPosition += (progressPosition - progressNowPosition) * 0.1;
    //   // 読み込みが完了した場合の処理
    //   if (progressNowPosition >= 100) {
    //     clearLoadWindow();
    //   }
    //   // イージング計算を完了させる
    //   if (progressNowPosition > 99.9) {
    //     progressNowPosition = 100;
    //   }
    // }
  // });
});
